import { Button, Form, NumberBox, SelectBox, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import { apiGetFileP, apiGetP, apiPostP } from '../../GanjiTools';
import { UniGrid } from '../UniGrid';
import ExportTool from './ExportTool';
import SideDivider from '../layout/SideDivider';
import CollapsibleBox from '../utils/CollapsibleBox';
import { style } from 'typestyle';
import Theme from '../theme/Theme';

class TankerReports extends Component {
    state = {
        tanker: this.props.tanker,
        //tankersLookup: window.tankersLookup ?? [],
        receivables: 0, payments: 0, moneyBalance: 0,
        loading: true,
    }

    static fetchtankersLookupP(forceReload) {
        return new Promise((resolve, reject) => {
            if (!forceReload && window.tankersLookup?.length > 0) {
                resolve?.(window.tankersLookup);
                return;
            }
            apiPostP('/api/dyna/rowsAsLookup/Tanker', {})
                .then(res => {
                    let { list, error } = res ?? { error: 'No response' };
                    if (error?.length > 0) {
                        reject?.(error);
                        return;
                    }
                    window.tankersLookup = list;
                    resolve?.(list);
                    console.log('tankersLookup=', tankersLookup);
                }).catch(reject)
        });
    }

    loadTankerReport = (id, whenDone) => {
        if (!(id > 0)) {
            window.notif('Invalid tanker id: ' + id);
            return;
        }

        apiGetP(`/api/parssaman/report/tanker/${id}`)
            .then(res => {
                let { error = 'No response.', ins, outs } = res ?? {};
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.setState({ receivables: ins, payments: outs, moneyBalance: ins - outs }, () => whenDone?.(id));
            })
            .catch(window.notif);
    }

    onSelectedTankerChanged = id => {
        let tanker = window.tankersLookup.find(x => x.id === id);
        this.setState({ tanker },
            () => this.loadTankerReport(id,
                _ => this.props.onSelectedTankerChanged?.(tanker)
            ));
    }

    onExportToExcel = () => {
        let op = { fieldEqualities: { fK_Tanker: `=${this.state.tanker?.id ?? 0}` } };

        apiGetFileP(`/api/parssaman/exportToExcel/deal?optionsJsn=${encodeURIComponent(JSON.stringify(op))}`, 'tanker_report.xlsx')
            .then(res => {
                if (res?.error?.length > 0) {
                    window.notif(res.error);
                    return;
                }
                console.log('ok. the file is downloaded.');
            })
            .catch(window.notif);
    }

    componentDidMount() {
        TankerReports.fetchtankersLookupP(true)
            .then(() => this.setState({ loading: false }))
            .catch(console.log);
        //.then(tankersLookup => this.setState({ tankersLookup }));
    }

    render() {
        if (this.state.loading)
            return (
                <p style={{ padding: '3rem' }}> صبر کنید...</p>
            );

        let title = 'نمایش سوابق', summary = '', width = this.props.width ?? `${SideDivider.bodyWidth - 150}px`;

        return (
            <div style={{ padding: '0 3rem' }}>
                <CollapsibleBox className={'loadorder-collapsibleboxd ' +
                    style({
                        background: Theme.col1('whitesmoke'),
                        borderRadius: '1rem',
                        color: Theme.col0()
                    })
                }
                    style={{ width, margin: this.props.collapsed ? '2px auto' : '1rem auto' }}

                    title={
                        <div className='loadorder-title'
                            style={{
                                height: '100%', display: 'flex', color: Theme.col0('steelblue'), // ,
                                justifyContent: 'center', alignItems: 'center', fontWeight: '700',
                            }}
                        >
                            <span style={{ fontWeight: '900' }}>{title}</span>
                        </div>
                    }
                    headerStyle={{
                        width: `calc(${width} - ${this.props.wizardMode ? -2 : 2}rem)`,
                        background: Theme.col1('whitesmoke'),
                        color: Theme.col0(),
                    }}
                    summary={
                        <span className='loadorder-summary'
                            style={{
                                margin: '0 1rem',
                                fontSize: '0.8rem',
                                color: Theme.col2('#550')
                            }}
                        >
                            {!Array.isArray(summary) ? summary : Card.renderCards('', summary)}
                        </span>
                    }

                    bodyStyle={{
                        ...this.props.style, ...this.stl, marginTop: '0',
                        borderRadius: /*this.props.collapsed ? '0' :*/ '0 0 1rem 1rem',
                        width: `calc(${width} - 2rem)`,
                        background: Theme.col1('whitesmoke'),
                    }}>
                    <Form rtlEnabled colCount={60} width={`calc(${width} - 2rem)`} labelLocation={window.mView ? 'top' : 'left'}>
                        <SimpleItem colSpan={60} label={{ text: 'انتخاب تانکر' }}>
                            <SelectBox rtlEnabled items={window.tankersLookup} valueExpr='id' displayExpr='summary'
                                value={this.state.tanker?.id}
                                onValueChanged={e => this.onSelectedTankerChanged(e.value)}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <SimpleItem colSpan={60}>
                            <UniGrid table='Mission' readOnly noMetaGrid height='20rem' paging={false} focusedRowEnabled={false}
                                titleFontSize={window.mView ? '1rem' : '1.2rem'}
                                title='مأموریت ها'
                                //field='fK_Tanker' equalTo={this.state.tanker?.id} field='fK_Tanker' equalTo={this.state.tanker?.id}
                                fieldEqualities={{ fK_Tanker: `=${this.state.tanker?.id ?? 0}` }}
                                //showFields={['fK_Remittance', 'fK_Material', 'fK_FromPoint', 'fK_ToPoint', 'tonnage', 'phee', 'pheeUnit']}
                                hideFields={['fK_Tanker', 'totalFreight', 'profit']}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={60}>
                            <UniGrid table='Deal' readOnly noMetaGrid title='پرداخت ها' titleFontSize={window.mView ? '1rem' : '1.2rem'}
                                height='20rem' focusedRowEnabled={false}
                                //field='fK_Tanker' equalTo={this.state.tanker?.id}
                                fieldEqualities={{ fK_Tanker: `=${this.state.tanker?.id ?? 0}` }}
                                hideFields={['fK_Tanker', 'ware', 'date']}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع مطالبات ها' }} colSpan={window.mView ? 60 : 30}>
                            <NumberBox readOnly key={'nbi_' + this.state.receivables} format=',##0'
                                value={this.state.receivables ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'مجموع پرداختی ها' }} colSpan={window.mView ? 60 : 30}>
                            <NumberBox readOnly key={'nbo_' + this.state.payments} format=',##0'
                                value={this.state.payments ?? 0}
                            />
                        </SimpleItem>

                        <SimpleItem label={{ text: 'تراز مالی' }} colSpan={60}>
                            <NumberBox readOnly format=',##0'
                                value={this.state.moneyBalance ?? 0}
                            />
                        </SimpleItem>
                    </Form>
                </CollapsibleBox>

                {['ادمین', 'اپراتور'].includes(window.user?.role) && this.state.tanker?.id > 0 &&
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button text={'پرداخت به تانکر'} width={window.mView ? '100%' : '12rem'} type='success'
                            onClick={() => this.props.onDeal?.(0, this.state.tanker)}
                        />
                    </div>
                }

                <div style={{ margin: '2rem 0 1rem 0', color: 'gray' }}>
                </div>

                <ExportTool table='deal' width={width} fileName='گزارش تانکر'
                    excludeFields={['fK_Tanker', 'fK_TruckOwner', 'fK_Customer', 'ware', 'dealType']}
                    extraFieldEqualities={[
                        { name: 'dealType', oper: '=', value1: 0, nature: 'number' },
                        { name: 'fK_Tanker', oper: '=', value1: this.state.tanker?.id, nature: 'number' }
                    ]}
                />
            </div>
        );
    }
}

export default TankerReports;